import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useAlert from '../../../../hooks/useAlert';
import { validateCategoryAdd } from '../../../../utils/validation';
import { addBrandAction, brandUpdate } from '../../../../redux/actions/BrandAction';
import { Update } from '@mui/icons-material';
import { updateCategory } from '../../../../redux/actions/categorysActions';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';

export const CategoryUpdate = ({ openDialog, handleCloseDialog, data }) => {
  const { showSuccessAlertCategoryUpdate, showErrorAlertCategoryUpdate } = useAlert();
  const authUserId = useSelector(state => state?.auth?.user?.id);
  const token = useSelector(state => state?.auth?.user?.accessToken?.token);
  const dispatch = useDispatch();
  const [selectedKdv, setSelectedKdv] = useState(null);
  const [value, setValue] = useState({ data });
  const [formErrors, setFormErrors] = useState({});
  useEffect(() => {
    setValue(data);
    setSelectedKdv(data?.vatRate)
  }, [data]);

  const handleInputChange = (e) => {
    const { name, value: inputValue } = e.target;
    setValue((prev) => ({ ...prev, [name]: inputValue }));
    setFormErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const updateBrand = async (e) => {
    e.preventDefault();
    value.parentId = data.parentId;
    value.vatRate = selectedKdv;
    const errors = validateCategoryAdd(value);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      try {
        await dispatch(updateCategory(value, token));
        showSuccessAlertCategoryUpdate();
        handleCloseDialog();
      } catch {
        showErrorAlertCategoryUpdate();
      }
    }
  };
  return (
    <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          color: 'black',
          fontWeight: 'bold',
          textAlign: 'center',
          padding: 2,
          marginBottom: 3,
        }}
      >
        Kategori Güncelle
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12}>
            <TextField
              size='small'

              fullWidth
              label="Marka ismi"
              variant="outlined"
              placeholder="Marka ismi"
              value={value?.name}
              name='name'
              onChange={handleInputChange}
              error={!!formErrors.name}
              helperText={formErrors.name}
            />

          </Grid>
          <Grid item xs={12} md={12}>
            <FormControl sx={{ flex: 1 }} fullWidth>
              <InputLabel>KDV Oranı</InputLabel>
              <Select
               name='vatRate'
                value={selectedKdv}
                onChange={(e) => setSelectedKdv(e.target.value)}
                label="KDV Oranı"
                error={!!formErrors.vatRate}
                helperText={formErrors.vatRate}
              >
                <MenuItem value={0}>%0</MenuItem>
                <MenuItem value={1}>%1</MenuItem>
                <MenuItem value={8}>%8</MenuItem>
                <MenuItem value={10}>%10</MenuItem>
                <MenuItem value={18}>%18</MenuItem>
                <MenuItem value={20}>%20</MenuItem>
              </Select>
            </FormControl>
          </Grid>

        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleCloseDialog}
          variant="outlined"
          startIcon={<CloseIcon />}
          sx={{
            borderRadius: 18,
            border: '1px solid #1F1B45',
            color: '#1F1B45',
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.875rem',
            padding: '10px 20px',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            '&:hover': {
              backgroundColor: '#F3F3F3',
              border: '1px solid #2C285A',
              color: '#2C285A',
            },
          }}
        >
          Kapat
        </Button>

        <Button
          onClick={updateBrand}
          variant="contained"
          startIcon={<SaveIcon />}
          sx={{
            borderRadius: 18,
            backgroundColor: '#1F1B45',
            color: '#FFFFFF',
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.875rem',
            padding: '10px 20px',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            '&:hover': {
              backgroundColor: '#2C285A',
              boxShadow: '0 6px 12px rgba(31, 27, 69, 0.4)',
            },
          }}
        >
          Kaydet
        </Button>
      </DialogActions>
    </Dialog>
  );
};